import { useContext } from "react";
import { useTranslation } from "react-i18next";
import FileDownloadedNotification from "./FileDownloadedNotification";
import JobsServiceApi from "../../../../../../../../api/jobsService/jobsServiceApi";
import useJobServiceApi from "../../../../../../../../api/jobsService/useJobServiceApi";
import { ConfigContext } from "../../../../../../../../context/ConfigContext";
import { Notification } from "../../hooks/useNotifications/useNotifications";

interface AllInvoicesNotificationProps {
  notification: Notification;
  accountId: string;
  expireNotification: (notificationId: number) => void;
  downloadFile: (url: string, fileName: string) => void;
}

const AllInvoicesNotification = ({
  notification,
  accountId,
  expireNotification,
  downloadFile,
}: AllInvoicesNotificationProps) => {
  const { t } = useTranslation("common");
  const {
    JOBS_SERVICE_URL,
    ENABLE_RBAC_AUTH_SUPPORT,
    ENABLE_RBAC_AUTH_SUPPORT_FOR_JOBS_SERVICE,
  } = useContext(ConfigContext);

  const { downloadJob } = useJobServiceApi();

  const isJobsApiAuthEnable =
    ENABLE_RBAC_AUTH_SUPPORT && ENABLE_RBAC_AUTH_SUPPORT_FOR_JOBS_SERVICE;

  const invoiceFileExcel =
    (jobId: string, fileName: string) => async (accessToken: string) => {
      const fileResponse = isJobsApiAuthEnable
        ? await downloadJob(jobId, accountId, fileName)
        : await JobsServiceApi.downloadJob(
            JOBS_SERVICE_URL,
            jobId,
            accountId,
            fileName,
            accessToken
          );

      return downloadFile(URL.createObjectURL(fileResponse.data), fileName);
    };

  const { id } = notification.payload;
  const successMessage = t(
    "notifications.invoiceFileDownloadSuccessNotificationMessage"
  );

  const failureMessage = t(
    "notifications.invoiceFileDownloadFailureNotificationMessage"
  );
  const generateDownloadLink = invoiceFileExcel(
    id,
    `${notification.payload.filename}.xlsx`
  );

  return (
    <FileDownloadedNotification
      notification={notification}
      expireNotification={() =>
        expireNotification(new Date(notification.createdAt).getTime())
      }
      successMessage={successMessage}
      failureMessage={failureMessage}
      downloadFunction={generateDownloadLink}
    />
  );
};

export default AllInvoicesNotification;
